export default "__VITE_ASSET__DYHJi6Ld__"